export const STATUS_CONFIG = {
  'Ativo': {
    'variant': 'ativa',
    'label': 'Assinatura ativa'
  },
  'Solicitou Cancelamento': {
    'variant': 'solicitouCancelamento',
    'label': 'Cancelamento agendado'
  },
  'Cancelado': {
    'variant': 'cancelada',
    'label': 'Assinatura cancelada'
  }
}

export function parseDate( isoOuData ) {
  if ( !isoOuData ) {
    return null
  }
  const data = new Date( isoOuData )
  return Number.isNaN( data.getTime() ) ? null : data
}

export function formatarRenovacaoFull( data ) {
  if ( !data ) {
    return '—'
  }
  const dia = String( data.getDate() ).padStart( 2, '0' )
  const mes = String( data.getMonth() + 1 ).padStart( 2, '0' )
  return `${dia}/${mes}/${data.getFullYear()}`
}
